import './modules/global';



// WEBPACK FOOTER //
// ./scripts/main.js